import React from "react";

function MinuteStepInput({ id, value, onChange, disabled = false, max }) {
  const applyMax = (digits) => {
    if (digits === "") return "";
    if (max == null) return digits;
    const num = Number(digits);
    if (Number.isNaN(num)) return digits;
    return num > max ? String(max) : digits;
  };

  const handleChange = (event) => {
    const raw = event.target.value;
    if (raw === "") {
      onChange("");
      return;
    }
    if (/^\d+$/.test(raw)) {
      onChange(applyMax(raw));
    }
  };

  const handleKeyDown = (event) => {
    if (["e", "E", "+", "-", ".", ","].includes(event.key)) {
      event.preventDefault();
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const digits = (event.clipboardData.getData("text") || "").replace(/\D/g, "");
    if (digits) onChange(applyMax(digits));
  };

  return (
    <input
      id={id}
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      className="form-control"
      placeholder="0"
      value={value ?? ""}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onPaste={handlePaste}
      disabled={disabled}
      style={{
        border: "1px solid #e2e8f0",
        borderRadius: "10px",
        padding: "10px 12px",
        fontSize: "14px",
        background: disabled ? "#f8fafc" : "#fff",
      }}
    />
  );
}

export default MinuteStepInput;
